import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Constants from '../utils/Constants';
import RoutePath from '../utils/routes/RoutePath';
import adminLogo from '../assets/img/Live_Agent_Logo.svg'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Actions from '../redux/actions';
import { Tooltip } from 'react-tooltip'

class ResponsiveNavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    paymentValiate = (e, vendor, paymentStatus) => {
        if (vendor === 'vendor' && paymentStatus == 0) {
            e.preventDefault()
        }
    }

    resolveLoginFlow = () => {
        const { getLoginDetails = {} } = this.props
        const { vendorTokenDetails = {}, isAR, paymentStatus, vendorLogo, argumentedReality } = getLoginDetails
        const route = this.props.match.path.split('/')
        const isAdmin = route[1] === "admin"
        const isVendor = route[1] === "vendor"
        const isFeedbackVendor = isVendor && Number(vendorTokenDetails?.userDetails?.Vendor?.isFeedback) === 1
        const isFullVendor = isVendor && !isFeedbackVendor
        const isSrmIpVendor = isFullVendor && Number(vendorTokenDetails?.userDetails?.Vendor?.isSrmIp) === 1
        return {
            route,
            isAdmin,
            isFeedbackVendor,
            isFullVendor,
            isSrmIpVendor,
            isAR,
            paymentStatus,
            vendorLogo,
            argumentedReality,
        }
    }

    render() {
        const {
            route,
            isAdmin,
            isFeedbackVendor,
            isFullVendor,
            isSrmIpVendor,
            isAR,
            paymentStatus,
            argumentedReality,
        } = this.resolveLoginFlow()

        return (
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-width">
                    <div className="modal-content content-part">
                        <div className="modal-header heading-modal">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body p-0">
                            <div className="logo-content">
                                <img src={adminLogo} className="img-fluid main-logo" alt="logo" />
                            </div>
                            <ul className="nav flex-column responsive_nav">
                                <React.Fragment>
                                    {isAdmin ? (
                                        <>
                                            <Link to={RoutePath.ADMIN_DASHBOARD_SCREEN} className={`nav-item link-item  ${route[2] === "dashboard" ? 'link-type' : ''}`}>
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal"><p className="m-0"><i className="fa-solid fa-gauge-high dashboard-icon"></i></p><p className="m-0">{Constants.DASHBOARD}</p></li>
                                            </Link>
                                            <Link to={RoutePath.ADMIN_VENDOR_LIST} className={`nav-item link-item  ${route[2] === "vendor" ? 'link-type' : ''}`}>
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal"><p className="m-0"><i className="fa-solid fa-user-group vendor-icon"></i></p><p className="m-0">{Constants.VENDOR}</p></li>
                                            </Link>
                                            <Link to={RoutePath.ADMIN_AGENT_LIST} className={`nav-item link-item ${route[2] === "agent" ? 'link-type' : ''}`}>
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                    <p className="m-0 "><i className="fa-solid fa-users agent-icon"></i></p>
                                                    <p className="m-0">{Constants.AGENT}</p>
                                                </li>
                                            </Link>
                                            <Link to={RoutePath.SUBSCRIPTION_LIST} className={`nav-item link-item ${route[2] === "subscription" ? 'link-type' : ''}`}>
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal"><p className="m-0"><i className="fa-solid fa-bell bell-icon"></i></p><p className="m-0">{Constants.SUBSCRIPTION}</p></li>
                                            </Link>
                                            <Link to={RoutePath.ADDON_LIST} className={`nav-item link-item ${route[2] === "addon" ? 'link-type' : ''}`}>
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                    <p className="m-0"><i className="fa-solid fa-circle-plus bell-icon"></i></p>
                                                    <p className="m-0">{Constants.ADDON}</p>
                                                </li>
                                            </Link>
                                            <Link to={RoutePath.ADMIN_AR_PRODUCTS} className={`nav-item link-item ${route[2] === "products" ? 'link-type' : ''}`} >
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                    <p className="m-0"><i className="fa-brands fa-unity bell-icon"></i></p>
                                                    <p className="m-0">AR Products</p>
                                                </li>
                                            </Link>
                                        </>
                                    ) : null}

                                    {isFeedbackVendor ? (
                                        <Link to={RoutePath.VENDOR_FEEDBACK} className={`nav-item link-item ${route[2] === "feedback" ? 'link-type' : ''}`}>
                                            <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                <p className="m-0"><i className="fa-regular fa-message bell-icon"></i></p>
                                                <p className="m-0">Feedback</p>
                                            </li>
                                        </Link>
                                    ) : null}

                                    {isFullVendor ? (
                                        <>
                                            <Link to={RoutePath.VENDOR_DASHBOARD_SCREEN} className={`nav-item link-item  ${route[2] === "dashboard" ? 'link-type' : ''}`}>
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal"><p className="m-0"><i className="fa-solid fa-gauge-high dashboard-icon"></i></p><p className="m-0">{Constants.DASHBOARD}</p></li>
                                            </Link>
                                            <Link to={RoutePath.VENDOR_AGENT_LIST} className={`nav-item link-item ${route[2] === "agent" ? 'link-type' : ''}`} onClick={(e) => this.paymentValiate(e, 'vendor', paymentStatus)}>
                                                <li className="nav-link link-content ps-lg-5 py-3 agentPaymentTooltip" data-bs-dismiss="modal">
                                                    <p className="m-0 "><i className="fa-solid fa-users agent-icon"></i></p>
                                                    <p className="m-0">{Constants.AGENT}
                                                        {(paymentStatus == 0) && <Tooltip anchorSelect=".agentPaymentTooltip" place="top">
                                                            Your subscription payment is not done
                                                        </Tooltip>}
                                                    </p>
                                                </li>
                                            </Link>
                                            <Link to={RoutePath.VENDOR_ADDON_LIST} className={`nav-item link-item ${route[2] === "addon" ? 'link-type' : ''}`} onClick={(e) => this.paymentValiate(e, 'vendor', paymentStatus)}>
                                                <li className="nav-link link-content ps-lg-5 py-3 addonPaymentTooltip" data-bs-dismiss="modal">
                                                    <p className="m-0"><i className="fa-solid fa-circle-plus bell-icon"></i></p>
                                                    <p className="m-0">{Constants.ADDON}
                                                        {(paymentStatus == 0) && <Tooltip anchorSelect=".addonPaymentTooltip" place="top">
                                                            Your subscription payment is not done
                                                        </Tooltip>}
                                                    </p>
                                                </li>
                                            </Link>
                                            <Link to={RoutePath.VENDOR_PROFILE_DETAILS} className={`nav-item link-item ${route[2] === "profile" ? 'link-type' : ''}`} >
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                    <p className="m-0"><i className="fa-solid fa-user bell-icon"></i></p>
                                                    <p className="m-0">Profile</p>
                                                </li>
                                            </Link>
                                            <Link to={RoutePath.VENDOR_VB_LIST} className={`nav-item link-item ${route[2] === "virtualBackground" ? 'link-type' : ''}`} >
                                                <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                    <p className="m-0"><i className="fa-solid fa-chalkboard bell-icon"></i></p>
                                                    <p className="m-0">Virtual Background</p>
                                                </li>
                                            </Link>
                                            {argumentedReality == 1 && isAR == 1 ? (
                                                <Link to={RoutePath.VENDOR_AR_PRODUCTS} className={`nav-item link-item ${route[2] === "products" ? 'link-type' : ''}`} onClick={(e) => this.paymentValiate(e, 'vendor', paymentStatus)}>
                                                    <li className="nav-link link-content ps-lg-5 py-3 arProductPaymentTooltip" data-bs-dismiss="modal">
                                                        <p className="m-0"><i className="fa-brands fa-unity bell-icon"></i></p>
                                                        <p className="m-0">AR Products
                                                            {(paymentStatus == 0) && <Tooltip anchorSelect=".arProductPaymentTooltip" place="top">
                                                                Your subscription payment is not done
                                                            </Tooltip>}
                                                        </p>
                                                    </li>
                                                </Link>
                                            ) : null}
                                            {isSrmIpVendor ? (
                                                <>
                                                    <Link to={RoutePath.VENDOR_SERVICE} className={`nav-item link-item ${route[2] === "service" ? 'link-type' : ''}`} >
                                                        <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                            <p className="m-0"><i className="fas fa-user-nurse"></i></p>
                                                            <p className="m-0">SRM Services</p>
                                                        </li>
                                                    </Link>
                                                    <Link to={RoutePath.VENDOR_WARD} className={`nav-item link-item ${route[2] === "ward" ? 'link-type' : ''}`} >
                                                        <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                            <p className="m-0"><i className="fas fa-building"></i></p>
                                                            <p className="m-0">SRM Wards</p>
                                                        </li>
                                                    </Link>
                                                    <Link to={RoutePath.VENDOR_HIERARCHY} className={`nav-item link-item ${route[2] === "hierarchy" ? 'link-type' : ''}`} >
                                                        <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                            <p className="m-0"><i className="fas fa-sitemap"></i></p>
                                                            <p className="m-0">Hierarchy Level</p>
                                                        </li>
                                                    </Link>
                                                    <Link to={RoutePath.VENDOR_CALL_SUMMARY} className={`nav-item link-item ${route[2] === "call-summary" ? 'link-type' : ''}`} >
                                                        <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                            <p className="m-0"><i className="fas fa-chart-bar"></i></p>
                                                            <p className="m-0">Call Summary</p>
                                                        </li>
                                                    </Link>
                                                    <Link to={RoutePath.VENDOR_ROOM} className={`nav-item link-item ${(route[2] === "room" && (route[3] === undefined || route[3] === 'add' || route[3] === 'edit' || route[3] === 'view')) ? 'link-type' : ''}`} >
                                                        <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                            <p className="m-0"><i className="fas fa-hospital"></i></p>
                                                            <p className="m-0">SRM Rooms</p>
                                                        </li>
                                                    </Link>
                                                    <Link to={RoutePath.VENDOR_ROOM_SERVICE} className={`nav-item link-item ${(route[2] === "room" && route[3] === "service") ? 'link-type' : ''}`} >
                                                        <li className="nav-link link-content ps-lg-5 py-3" data-bs-dismiss="modal">
                                                            <p className="m-0"><i className="fas fa-bed"></i></p>
                                                            <p className="m-0">SRM Room Services</p>
                                                        </li>
                                                    </Link>
                                                </>
                                            ) : null}
                                        </>
                                    ) : null}
                                </React.Fragment>
                            </ul>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
export const mapStateToProps = (state) => {
    return {
        getLoginDetails: Actions.getLoginDetails(state)
    }
};
export default withRouter(connect(mapStateToProps, {
})(ResponsiveNavBar));
